import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import ParkScreenHero from './ParkScreenHero/ParkScreenHero';
import { PassesAndBundles } from './PassesAndBundles/PassesAndBundles';
import { EnhanceYourVisit } from './EnhanceYourVisit/EnhanceYourVisit';
import { ParksAndAttractions } from './ParksAndAttractions/ParksAndAttractions';
import { ExperiencesBeginHere } from './ExperiencesBeginHere/ExperiencesBeginHere';
import { ThingsToDo } from './ThingsToDo/ThingsToDo';
import { GetYourTicketsBlock } from './GetYourTicketsBlock/GetYourTicketsBlock';
import { FAQs } from './FAQs/FAQs';
import { GuestDelights } from './GuestDelights/GuestDelights';
import { SocialBlock } from './SocialBlock/SocialBlock';

const ParkScreen = ({ venue, events }) => {
  const className = useClassName('ParkScreen');

  return (
    <div className={className('container')}>
      <ParkScreenHero venue={venue} />
      <PassesAndBundles venue={venue} />
      <EnhanceYourVisit venue={venue} />
      <ParksAndAttractions venue={venue} />
      <ExperiencesBeginHere venue={venue} events={events} />
      <ThingsToDo venue={venue} />
      <GetYourTicketsBlock venue={venue} />
      <FAQs venue={venue} />
      <GuestDelights venue={venue} />
      <SocialBlock venue={venue} />
    </div>
  );
};

ParkScreen.propTypes = {
  venue: PropTypes.shape({
    parkScreen: PropTypes.object.isRequired,
  }).isRequired,
};

export default ParkScreen;
